import React from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import ItinerarySearchForm from './ItinerarySearchForm'
import { searchForOnRoute } from '../../../../actions'

const ItinerarySearch = ({ dispatchSearchForOnRoute }) => {

  const handleSubmit = ({ destination }) => {
    const { label } = destination
    dispatchSearchForOnRoute(label)
  }

  return (
    <div>
      <ItinerarySearchForm onSubmit={handleSubmit} />
    </div>
  )
}

ItinerarySearch.propTypes = {
  dispatchSearchForOnRoute: PropTypes.func.isRequired,
}

const mapDispatchToProps = {
  dispatchSearchForOnRoute: searchForOnRoute
}

export default connect(null, mapDispatchToProps)(ItinerarySearch)
